<template>
  <div>
    <div v-if="menu.is_kiosk_horiz_categ" class="w-full pt-6 relative">
      <div class="flex justify-center" v-if="showCategories">
        <div
          :class="[
            'relative mx-10 mt-6 border-opacity-25',
            desktopMode && !hasKiosk
              ? 'border-b-2 w-3/5'
              : 'border-2 rounded-xl w-11/12 mx-20',
            kioskBorder,
          ]"
          :style="makeStyles(categoryCarouselRadius, categoryCarouselBorderColor)"
        >
          <Carousel
            @change="onSelect"
            ref="carousel2"
            :options="{
              perView: 3,
              gap: 30,
              breakPoint: {
                1000: {
                  perView: 3,
                },
              },
            }"
          >
            <CarouselSlide
              v-for="(item, i) in menuCategories"
              v-bind:key="item.id"
              :index="i"
              class="relative"
            >
              <div
                ref="category"
                :class="[index != i && 'opacity-60']"
                class="block"
                @click="handleCarouselClick(i)"
                v-if="((hasKiosk && !isMobileDevice) ? (currentKioskMode == lang['take_away'][language]) ? item.is_take_out : (currentKioskMode == lang['dine_in'][language] ? item.is_dine_in : true) : true)"
              >
                <span class="hidden" id="categoryId">{{ item.Id }}</span>
                <div
                  :class="[
                    'flex justify-center',
                    desktopMode ? 'h-24' : 'h-48',
                  ]"
                  :style="categoryCarouselHeight"
                >
                  <img
                    :src="item.picture_url"
                    :class="[
                      'h-3/4',
                      desktopMode ? 'object-contain' : 'object-cover',
                    ]"
                  />
                </div>
                <div
                  :class="[
                    'w-full flex justify-center',
                    desktopMode ? '' : '-mt-8',
                  ]"
                >
                  <div :class="['namePosition']">
                    <p
                      id="currentCategoryTitle"
                      :class="[
                        'pb-3 text-gray-800',
                        desktopMode ? 'text-lg' : 'text-xl',
                      ]"
                      :style="makeStyles(kioskNavCategoryName, hasKiosk&&titleFont, hasKiosk&&titleTextTransform, kioskNavCategoryNameHeight)"
                      ref="title"
                    >
                      {{ item[`name_${language}`] }}
                    </p>
                  </div>
                </div>
              </div>
            </CarouselSlide>
          </Carousel>
          <div
            class="absolute left-1/2 transform -translate-x-1/2 translate-y-px bottom-0 rounded-t-xl transition-all ease-linear duration-200"
            :style="`width: ${currentTitleWidth}px; height: ${
              desktopMode ? 4 : 6
            }px; ${kioskCurrentCatBorder}`"
          />
        </div>
      </div>
      <p
        v-if="showCategories"
        :style="makeStyles(kioskCategoryTitle,hasKiosk&&titleFont)"
        class="w-full text-center text-4xl font-bold mt-10 2xl:block"
        :class="{'hidden':!hasKiosk}"
      >
        {{ currentTitle }}
      </p>
    </div>

    <div v-else class="mt-10">
      <StaticVerticalMenu ref="staticVerticalMenu" v-if="isStaticSideMenu" :index="index" :desktopMode="desktopMode" @onSelect="onSelect" @carouselClick="handleCarouselClick" />
      <div v-else>

           <hooper
        v-if="menu.desktop_kiosk_left_bar && !isSearchKiosk"
        :vertical="true"
        :style="makeStyles(kioskBorder,'height: 80vh',categoryCarouselBorderColor, verticalCategoryCarouselWidth, verticalCategoryCarouselBackgroundColor, verticalCategoryCarouselHeight, verticalCategoryCarouselBorderRadius)"
        :class="[
          'relative ml-12 mt-6 border-opacity-25 border-l-2',
        ]"
        :itemsToShow="itemsToShow"
        :centerMode="true"
        :infiniteScroll="true"
        ref="carousel3"
        @change="onSelect"
        @click="onSelect"
        :keysControl="true"
      >
        <slide v-for="(item, i) in menuCategories" v-bind:key="item.id"
        :style="index == i ? (kioskCurrentCatBorderLeft, categoryCarouselBackgroundColor): ''">
          <div
          v-if="((hasKiosk && !isMobileDevice) ? (currentKioskMode == lang['take_away'][language]) ? item.is_take_out : (currentKioskMode == lang['dine_in'][language] ? item.is_dine_in : true) : true)"
            ref="category"
            :class="[
              index != i && 'opacity-60',
              index == i ? 'border-l-4' : '',
              'cursor-pointer block',
            ]"
            :style="index == i ? (kioskCurrentCatBorderLeft): ''"
            @click="handleCarouselClick(i)"
          >
            <span class="hidden" id="categoryId">{{ item.Id }}</span>
            <div
                v-if="item.picture_url"
                :class="['flex justify-center', desktopMode ? 'h-32' : 'h-48']"
              >
              <span :class="['w-3/5 flex justify-center z-10', verticalCategoryCarouselWidth !== 'false' ? 'items-center' : '']">
              <span class='fade'
              :style="categoryCarouselHeight">
                <img
                  :src="item.picture_url"
                  :class="[
                    'fade-img h-full rounded-lg',
                    desktopMode ? 'object-contain' : 'object-contain',
                  ]"
                />
              </span>
              </span>
              </div>
              <div
                :class="[
                  'w-full flex justify-center pb-4',
                  // desktopMode ? hasKiosk && '-mt-8' : '-mt-8',
                  // item.picture_url ? 'absolute -bottom-2' : '',
                ]"
              >
                <div :class="['namePosition text-center']">
                  <p
                    id="currentCategoryTitle"
                    :class="[
                      'text-gray-800',
                      desktopMode ? 'text-lg' : 'text-xl',
                    ]"
                    :style="makeStyles(kioskNavCategoryName , titleFont,titleTextTransform)"
                    ref="title"
                  >
                    {{ item[`name_${language}`] }}
                  </p>
                </div>
              </div>
          </div>
        </slide>
      </hooper>
      </div>
    </div>
  </div>
</template>

<script>
import lang from "../lang";
import { mapGetters } from "vuex";

import Carousel from "../components/Carousel.vue";
import CarouselSlide from "../components/CarouselSlide.vue";
import { Hooper, Slide } from "hooper";
import "hooper/dist/hooper.css";
import _ from "lodash";
import StaticVerticalMenu from "./StaticVerticalMenu.vue";

export default {
  data() {
    return {
      index: 0,
      currentTitle: "",
      currentTitleWidth:0,
      test: false,
      lang: lang,
      slideHeight:0
    };
  },
  props: {
    desktopMode: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
  components: {
    Carousel,
    CarouselSlide,
    Hooper,
    Slide,
    StaticVerticalMenu
  },
  watch: {
    currentTitle() {
      if(!this.$refs.category) return
      const width = this.$refs.category[this.index]?.querySelector("p").offsetWidth;
      if(width) this.currentTitleWidth = width;
    },
    isStaticSideMenu() {
      this.setSlideHeight();
    }
  },
  computed: {
    ...mapGetters([
      "isSearchInput",
      "isSearchKiosk",
      "infiniteScroll",
      "menuCategories",
      "selectedMenuCategory",
      "language",
      "categoryId",
      "menu",
      "isCategorySubItem",
      "isSubSubCategory",
      "hasKiosk",
      "menuHash",
      "currentKioskMode",
      "isMobileDevice",
     
    ]),
    ...mapGetters("Theme", [
      "categoryCarouselRadius",
      "kioskBorder",
      "titleFont",
      "titleTextTransform",
      "kioskCurrentCatBorder",
      "kioskCategoryTitle",
      "kioskBorderColor",
      "kioskNavActiveBarColor",
      "kioskCurrentCatBorderLeft",
      "kioskNavCategoryName",
      "categoryCarouselHeight",
      "categoryCarouselBorderColor",
      "kioskNavCategoryNameHeight",
      "categoryCarouselBackgroundColor",
      "verticalCategoryCarouselWidth",
      "carouselItemsCount",
      "verticalCategoryCarouselBackgroundColor",
      "verticalCategoryCarouselHeight",
      "verticalCategoryCarouselBorderRadius",
      "customThemeVariables",
       "isStaticSideMenu"
    ]),  
    itemsToShow() {
      if (this.carouselItemsCount && this.hasKiosk) {
        if (this.isStaticSideMenu) return this.menuCategories.length + 2;
        
        return Number(this.carouselItemsCount);
      }

      return window.innerHeight > 900 ? 4.5 : 3;
  },
    showCategories() {
      return this.menuCategories.length > 1;
    },
  },
  created() {
    window.$eventBus.$on("directToBannerLink", (data) => {
      this.handleCarouselClick(data)
    });
  },
  beforeDestroy() {
      window.$eventBus.$off("directToBannerLink");
    },
  methods: {
    handleCarouselClick(index, emitCategoryChange = true) {
      if (this.$refs.carousel2) {
        this.$refs.carousel2.glide.go(`=${index}`);
      } else {
        if (this.$refs.carousel3) {
          this.$refs.carousel3.slideTo(index);
          if (this.infiniteScroll && this.$refs.category) {
            this.onSelectInfinity(index, emitCategoryChange);
          } else {
            this.onSelect(index);
          }
        }else {
            this.onSelect(index);
          }
      }
    },
    // update the category, subcategory and route when changing the category
    onSelect(newIndex) {
      this.$store.commit("updateSearchItemInput", "")
      this.$store.commit("updateIsSearchKiosk", false)
      const cat = !this.isStaticSideMenu ? this.$refs.category : this.$refs.staticVerticalMenu.$refs.category;
      if (cat) {
        let vm = this;
        this.index = newIndex;

        let item = parseInt(
          cat[this.index].querySelector("span").innerText
        );
        this.currentTitle = cat[this.index].querySelector("p").innerText;
        this.$store.commit(
          "updateSelectedMenuCategory",
          this.menuCategories[newIndex]
        );
        this.$store.commit("updateCategoryId", item);
        if (!this.menuCategories[newIndex].hasSubCategories) {
          this.$store.dispatch("GET_CATEGORY");
          this.$router
            .push("/" + this.$route.params.menuHash + "/sub/category/" + item)
            .catch(() => {});
          this.$store.commit("updateIsCategorySubItem", false);
        } else {
          if (!this.isCategorySubItem) {
            this.$store.commit(
              "updateSubCategoryId",
              this.menuCategories[newIndex].Id
            );
            this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
            this.$store.commit(
              "updateMenuCategoriesCategories",
              this.menuCategories[newIndex]
            );
            this.$router
              .push(
                "/" +
                  this.$route.params.menuHash +
                  "/category/" +
                  this.menuCategories[newIndex].Id
              )
              .catch(() => {});

            this.$store.commit("updateIsCategorySubItem", false);
          }
        }
      }
    },
    onSelectInfinity(newIndex, emitCategoryChange = true) {
      if (this.$refs.category) {
        let vm = this;
        this.index = newIndex;

        let item = parseInt(
          vm.$refs.category[this.index].querySelector("span").innerText
        );
        this.currentTitle = this.$refs.category[this.index].querySelector("p").innerText;
        this.$store.commit(
          "updateSelectedMenuCategory",
          this.menuCategories[newIndex]
        );
        this.$store.commit("updateCategoryId", item);
        if (emitCategoryChange) {
          this.$emit("category-changed", item);
        }
        if (!this.menuCategories[newIndex].hasSubCategories) {
          // this.$store.dispatch("GET_CATEGORY");
          this.$router
            .push("/" + this.$route.params.menuHash + "/sub/category/" + item)
            .catch(() => {});
          this.$store.commit("updateIsCategorySubItem", false);
        } else {
          if (!this.isCategorySubItem) {
            // this.$store.commit(
            //   "updateSubCategoryId",
            //   this.menuCategories[newIndex].Id
            // );
            // this.$store.dispatch("GET_MENU_SUB_CATEGORIES");
            // this.$store.commit(
            //   "updateMenuCategoriesCategories",
            //   this.menuCategories[newIndex]
            // );
            // this.$router
            //   .push(
            //     "/" +
            //       this.$route.params.menuHash +
            //       "/category/" +
            //       this.menuCategories[newIndex].Id
            //   )
            //   .catch(() => {});
            // this.$store.commit("updateIsCategorySubItem", false);
          }
        }
      }
    },
    initializeCarouselTitleBorder() {
      if(!this.$refs.category) return
      const targetElement = this.$refs.category[0].querySelector("p");
      const resizeObserver = new ResizeObserver((entries) => {
        for (let entry of entries) {
          if(entry.contentRect.width === 0) return;
          this.currentTitleWidth = entry.contentRect.width;
          resizeObserver.unobserve(targetElement);
          resizeObserver.disconnect();
        }
      });
      resizeObserver.observe(targetElement);
    },
    setSlideHeight() {
      if (this.isStaticSideMenu) {
        const hooperList = this.$el.querySelector('.hooper-list');
        const computedStyle = window.getComputedStyle(hooperList);
        const paddingTop = parseFloat(computedStyle.paddingTop);
        const paddingBottom = parseFloat(computedStyle.paddingBottom);
        const height = hooperList.clientHeight;
        const heightMinusPadding = height - paddingTop - paddingBottom;
        const slideHeight = heightMinusPadding / (this.menuCategories.length);
        return this.slideHeight = `${slideHeight}px`;
      }
      return this.slideHeight = this.categoryCarouselHeight;
    }
  },
  mounted() {
    // Select the first element with the class 'hooper-list'
    this.$nextTick(() => {
      if (this.menuCategories.length) {
        if (this.menuCategories[0].name_nl) {
          this.currentTitle = this.menuCategories[0].name_nl;
        } else {
          this.currentTitle = this.menuCategories[0].name_en;
        }
      }
      
    });
    this.initializeCarouselTitleBorder();
    this.setSlideHeight(); 
    let self = this;
    let categoryIndex = _.findIndex(this.menuCategories, function (o) {
      return o.Id == self.categoryId;
    });
    this.handleCarouselClick(categoryIndex);
  },
};
</script>

<style>
/* .namePosition {
    position: relative;
    overflow: visible;
    width: fit-content
  }
  .namePosition::after {
    content: ' ';
    position: absolute;
    left: 0px;
    right: 0px;
    bottom: 0px;
    height: 6px;
    background-color: #bd4423;
    opacity: 0;
    transform: translateY(1px);
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
    transition: all .3s ease;
  }
  .glide__slide--active .namePosition::after {
    opacity: 1;
  } */
.carousel-3d-slide {
  background: white;
}
.carousel-3d-container[data-v-07917306] {
  width: 90% !important;
  position: static !important;
}
.prev[data-v-05517ad0] {
  left: 35px !important;
  top: -15px !important;
}
.next[data-v-05517ad0] {
  right: 35px !important;
  top: -15px !important;
}
.next[data-v-05517ad0],
.prev[data-v-05517ad0] {
  display: flex;
  justify-content: center !important;
  border-radius: 50px;
  height: 35px !important;
  width: 35px !important;
  align-content: center !important;
  align-items: center !important;
}
.next[data-v-05517ad0] span,
.prev[data-v-05517ad0] span {
  margin-top: -3px;
  font-size: 35px !important;
}
.carousel-3d-slider .carousel-3d-slide {
  display: none !important;
}
.carousel-3d-slider .carousel-3d-slide.current {
  display: block !important;
}
.carousel-3d-slider .carousel-3d-slide[class*="left-"] {
  display: block !important;
}
.carousel-3d-slider .carousel-3d-slide[class*="right-"] {
  display: block !important;
}
.carousel-3d-controls[data-v-05517ad0] {
  z-index: 999 !important;
}
.fade{
  box-shadow: inset 0 0 20px white;
}
.fade-img{
  position: relative;
  z-index: -2;
}

</style>
